import apis from '@/api'

export default {
  data() {
    return {
      isCollect: false
    }
  },
  created() {
    this.hasMenuCollect(this.$route.query.currentMenu).then((data) => {
      this.isCollect = data.hasMenuStar
    })
  },
  methods: {
    hasMenuCollect(menuId) {
      const request = {
        ...apis.APP_PAGE.HAS_MENU_COLLECT,
        params: {
          menuId
        }
      }
      return new Promise((resolve, reject) => {
        this.$request(request).asyncThen(resp => {
          if (resp.code === 'ok') {
            resolve(resp.data)
          }
        }, (err) => {
          reject(err)
        }).asyncErrorCatch(err => {
          reject(err)
        })
      })
    },
    handleCollect() {
      if (this.isCollect) {
        this.removeMenuCollect(this.$route.query.currentMenu).then(() => {
          this.isCollect = false
        })
      } else {
        this.addMenuCollect(this.$route.query.currentMenu).then(() => {
          this.isCollect = true
        })
      }
    },
    removeMenuCollect(menuId) {
      const request = {
        ...apis.APP_PAGE.REMOVE_MENU_COLLECT,
        params: {
          menuId
        }
      }
      return new Promise((resolve, reject) => {
        this.$request(request).asyncThen(resp => {
          if (resp.code === 'ok') {
            resolve(resp.data)
          }
        }, (err) => {
          reject(err)
        }).asyncErrorCatch(err => {
          reject(err)
        })
      })
    },
    addMenuCollect(menuId) {
      const request = {
        ...apis.APP_PAGE.ADD_MENU_COLLECT,
        params: {
          menuId
        }
      }
      return new Promise((resolve, reject) => {
        this.$request(request).asyncThen(resp => {
          if (resp.code === 'ok') {
            resolve(resp.data)
          }
        }, (err) => {
          reject(err)
        }).asyncErrorCatch(err => {
          reject(err)
        })
      })
    }
  }
}
